import "./assets/styles/styles.scss";
import { BrowserRouter as Router, Switch } from "react-router-dom";
// Import Routes all
import {
  publicRoutes,
  authProtectedRoutes,
  // globalUserRoutes,
  superAdminRoutes,
  customerRoutes,
  salesPersonRoutes,
  greUserRoutes,
  closingTeamLeadRoutes,
  regionalHeadRoutes,
  projectHeadRoutes,
  verticalHeadRoutes,
  subVerticalHeadRoutes,
  crmUserRoutes,
  sourcingTeamLeadRoutes,
  sourcingManagerRoutes,
} from "./routes";
// Import all middleware
import Authmiddleware from "./routes/route";
import { QueryClient, QueryClientProvider } from "react-query";
import React, { Suspense, useEffect, lazy } from "react";
import AuthLayout from "./Layout/AuthLayout";
import NonAuthLayout from "./Layout/NonAuthLayout";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { getUserType } from "store/userType";
// import { deleteFromStorage, getFromStorage } from "utils/storage";
import ToasterMessage from "components/common/ToasterMessage";
import SelectProjectModal from "components/common/SelectProjectModal";
import { commonData } from "data/CommonDataPoint";
// import axios from "axios";
// import { createEndpoint } from "config/apiEndpoints";
import { getFromStorage } from "utils/storage";
import PageLoader from "components/common/PageLoader";
import { generalStore } from "store/generalStore";
import SessionHandler from "SessionHandler";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import RoleChangeModal from "components/common/RoleChangeModal";
import useAutoRefresh from "hooks/common/useAutoRefresh";
import { MultiBackend, TouchTransition } from "react-dnd-multi-backend";
import { TouchBackend } from "react-dnd-touch-backend";
const queryClient = new QueryClient();

const HTML5toTouch = {
  backends: [
    {
      id: "html5",
      backend: HTML5Backend,
      preview: false,
    },
    {
      id: "touch",
      backend: TouchBackend,
      preview: true,
      transition: TouchTransition,
      options: {
        enableMouseEvents: true,
      },
    },
  ],
};
function App() {
  const isUserType = getUserType((state) => state.isUserType);
  const setUserType = getUserType((state) => state.setUserType);
  const isUserData = getFromStorage("user_data");
  const userData = getUserType((state) => state?.userData);
  const logoutLoader = generalStore((state) => state.logoutLoader);
  const [msalHandled, setMsalHandled] = React.useState(false);
  // const userData = getFromStorage
  // const isUserType = getFromStorage("user_data")?.user_role;
  // isUserType?.replace(/\s/g, "")
  useAutoRefresh();

  // const { instance, inProgress } = useMsal();

  // useEffect(() => {
  //   if (inProgress === InteractionStatus.None) {
  //     instance
  //       .handleRedirectPromise()
  //       .then((response) => {
  //         if (response) {
  //           const accessToken = response.accessToken;
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Redirect handling error", error);
  //       })
  //       .finally(() => {
  //         setMsalHandled(true); // 🔥 KEY
  //       });
  //   }
  // }, [instance, inProgress]);

  const { accounts, inProgress, instance } = useMsal();

  useEffect(() => {
    if (inProgress === InteractionStatus.None && accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
      setMsalHandled(true);
    }

    if (inProgress === InteractionStatus.None && accounts.length === 0) {
      setMsalHandled(true);
    }
  }, [accounts, inProgress, instance]);

  // const account = instance.getActiveAccount() || accounts[0];

  // const tokenResponse = await instance.acquireTokenSilent({
  //   scopes: ["User.Read"],
  //   account
  // });

  // const accessToken = tokenResponse.accessToken;

  // const { accounts, inProgress, instance } = useMsal();

  // useEffect(() => {
  //   if (inProgress === InteractionStatus.None && accounts.length > 0) {
  //     instance.setActiveAccount(accounts[0]);
  //     setMsalHandled(true);
  //   }

  //   if (inProgress === InteractionStatus.None && accounts.length === 0) {
  //     setMsalHandled(true);
  //   }
  // }, [accounts, inProgress, instance]);

  // const account = instance.getActiveAccount() || accounts[0];

  // const tokenResponse = await instance.acquireTokenSilent({
  //   scopes: ["User.Read"],
  //   account
  // });

  // const accessToken = tokenResponse.accessToken;

  // useEffect(() => {
  //   if (inProgress !== InteractionStatus.None) return; // 🔥 MUST

  //   if (!msalHandled) return;

  //   if (window?.location?.pathname === "/") {
  //     const userType = isUserType?.replace(/\s/g, "");

  //     switch (userType) {
  //       case commonData?.customerRole:
  //         window.location.replace(`/${userType}/user-dashboard`);
  //         break;
  //       case commonData?.admin:
  //         window.location.replace(`/${userType}/project-listing`);
  //         break;
  //       case commonData?.projectHead:
  //       case commonData?.regionalHead:
  //       case commonData?.closingTeamLeadRole:
  //       case commonData?.salesRole:
  //       case commonData?.sourcingTeamLeadRole:
  //       case commonData?.sourcingManagerRole:
  //       case commonData?.verticalHead:
  //       case commonData?.subVerticalHead:
  //       case commonData?.CRM:
  //         window.location.replace(`/${userType}/dashboard`);
  //         break;
  //       case commonData?.greRole:
  //         window.location.replace(`/${userType}/customer-search`);
  //         break;
  //       default:
  //         // Handle any cases not covered above
  //         break;
  //     }
  //   }

  //   if (window?.location?.pathname == "/" && !isUserType) {
  //     window.location.replace("/login");
  //   }
  // }, [inProgress]);

  return (
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        {isUserType?.replace(/\s/g, "") == "globalUser" ? (
          <DndProvider backend={MultiBackend} options={HTML5toTouch}>
            {/* <SessionHandler /> */}
            <Router>
              <Suspense fallback={<PageLoader type={"transperent"} />}>
                <Switch>
                  {publicRoutes?.map((route, idx) => (
                    <Authmiddleware
                      path={route.path}
                      layout={NonAuthLayout}
                      component={route.component}
                      key={idx}
                      isAuthProtected={false}
                      exact
                    />
                  ))}
                </Switch>
              </Suspense>
            </Router>
          </DndProvider>
        ) : (
          <DndProvider backend={MultiBackend} options={HTML5toTouch}>
            {/* <SessionHandler /> */}
            <Router>
              <Suspense fallback={<PageLoader type={"page-loader"} />}>
                <Switch>
                  {publicRoutes?.map((route, idx) => (
                    <Authmiddleware
                      path={route.path}
                      layout={NonAuthLayout}
                      component={route.component}
                      key={idx}
                      isAuthProtected={false}
                      exact
                    />
                  ))}
                  {isUserType == null &&
                    [
                      { path: window?.location?.pathname, component: <></> },
                    ]?.map((route, idx) => (
                      <Authmiddleware
                        path={route.path}
                        layout={NonAuthLayout}
                        component={route.component}
                        key={idx}
                        isAuthProtected={true}
                        exact
                      />
                    ))}
                  {isUserType?.replace(/\s/g, "") == commonData?.admin
                    ? superAdminRoutes?.map((route, idx) => (
                        <Authmiddleware
                          path={route.path}
                          layout={AuthLayout}
                          component={route.component}
                          key={idx}
                          isAuthProtected={true}
                          exact
                        />
                      ))
                    : isUserType?.replace(/\s/g, "") == commonData?.customerRole
                      ? customerRoutes?.map((route, idx) => (
                          <Authmiddleware
                            path={route.path}
                            layout={AuthLayout}
                            component={route.component}
                            key={idx}
                            isAuthProtected={true}
                            exact
                          />
                        ))
                      : isUserType?.replace(/\s/g, "") == commonData?.greRole
                        ? greUserRoutes?.map((route, idx) => (
                            <Authmiddleware
                              path={route.path}
                              layout={AuthLayout}
                              component={route.component}
                              key={idx}
                              isAuthProtected={true}
                              exact
                            />
                          ))
                        : isUserType?.replace(/\s/g, "") ==
                            commonData?.closingTeamLeadRole
                          ? closingTeamLeadRoutes?.map((route, idx) => (
                              <Authmiddleware
                                path={route.path}
                                layout={AuthLayout}
                                component={route.component}
                                key={idx}
                                isAuthProtected={true}
                                exact
                              />
                            ))
                          : isUserType?.replace(/\s/g, "") ==
                              commonData?.salesRole
                            ? salesPersonRoutes?.map((route, idx) => (
                                <Authmiddleware
                                  path={route.path}
                                  layout={AuthLayout}
                                  component={route.component}
                                  key={idx}
                                  isAuthProtected={true}
                                  exact
                                />
                              ))
                            : isUserType?.replace(/\s/g, "") ==
                                commonData?.regionalHead
                              ? regionalHeadRoutes?.map((route, idx) => (
                                  <Authmiddleware
                                    path={route.path}
                                    layout={AuthLayout}
                                    component={route.component}
                                    key={idx}
                                    isAuthProtected={true}
                                    exact
                                  />
                                ))
                              : isUserType?.replace(/\s/g, "") ==
                                  commonData?.projectHead
                                ? projectHeadRoutes?.map((route, idx) => (
                                    <Authmiddleware
                                      path={route.path}
                                      layout={AuthLayout}
                                      component={route.component}
                                      key={idx}
                                      isAuthProtected={true}
                                      exact
                                    />
                                  ))
                                : isUserType?.replace(/\s/g, "") ==
                                    commonData?.verticalHead
                                  ? verticalHeadRoutes?.map((route, idx) => (
                                      <Authmiddleware
                                        path={route.path}
                                        layout={AuthLayout}
                                        component={route.component}
                                        key={idx}
                                        isAuthProtected={true}
                                        exact
                                      />
                                    ))
                                  : isUserType?.replace(/\s/g, "") ==
                                      commonData?.subVerticalHead
                                    ? subVerticalHeadRoutes?.map(
                                        (route, idx) => (
                                          <Authmiddleware
                                            path={route.path}
                                            layout={AuthLayout}
                                            component={route.component}
                                            key={idx}
                                            isAuthProtected={true}
                                            exact
                                          />
                                        ),
                                      )
                                    : isUserType?.replace(/\s/g, "") ==
                                        commonData?.CRM
                                      ? crmUserRoutes?.map((route, idx) => (
                                          <Authmiddleware
                                            path={route.path}
                                            layout={AuthLayout}
                                            component={route.component}
                                            key={idx}
                                            isAuthProtected={true}
                                            exact
                                          />
                                        ))
                                      : isUserType?.replace(/\s/g, "") ==
                                          commonData?.sourcingTeamLeadRole
                                        ? sourcingTeamLeadRoutes?.map(
                                            (route, idx) => (
                                              <Authmiddleware
                                                path={route.path}
                                                layout={AuthLayout}
                                                component={route.component}
                                                key={idx}
                                                isAuthProtected={true}
                                                exact
                                              />
                                            ),
                                          )
                                        : isUserType?.replace(/\s/g, "") ==
                                            commonData?.sourcingManagerRole
                                          ? sourcingManagerRoutes?.map(
                                              (route, idx) => (
                                                <Authmiddleware
                                                  path={route.path}
                                                  layout={AuthLayout}
                                                  component={route.component}
                                                  key={idx}
                                                  isAuthProtected={true}
                                                  exact
                                                />
                                              ),
                                            )
                                          : ""}
                </Switch>
              </Suspense>
              <SelectProjectModal />
              <RoleChangeModal />
            </Router>
          </DndProvider>
        )}
        {logoutLoader && <PageLoader type={"transperent"} />}

        <ToasterMessage />
      </QueryClientProvider>
    </React.Fragment>
  );
}

export default App;
